import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  ChangeDetectorRef,
  effect,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

@Component({
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabBarComponent implements AfterViewInit {
  @Input() tabs: { label: string; id: string }[] = [];
  @Input() buttonType: 'pill' | 'tab' = 'pill';
  @Input() selectedTabIndex = 0;
  @Output() tabSelected = new EventEmitter<string>();

  private changeDetection = inject(ChangeDetectorRef);
  private themeService = inject(ThemeService);
  currentTheme = this.themeService.currentTheme;

  underlineTransform = 'translateX(0)';
  underlineWidth = '0px';
  circleRadius = '50px';
  shouldAnimate = false;

  constructor() {
    effect(() => {
      this.currentTheme();
    });
  }

  ngAfterViewInit(): void {
    this.updateUnderline();
    this.shouldAnimate = true;
  }

  get underlineStyle(): string {
    return this.themeService.tabConfig().style;
  }

  onTabClick(index: number): void {
    this.selectedTabIndex = index;
    this.tabSelected.emit(this.tabs[index].id);
    this.updateUnderline();
  }

  private updateUnderline(): void {
    const tabElements = Array.from(document.querySelectorAll('.tab-bar > *')).filter(
      (el) => !el.classList.contains('tab-bar__underline'),
    );

    if (tabElements.length > 0) {
      const selectedElement = tabElements[this.selectedTabIndex] as HTMLElement;
      if (selectedElement) {
        const { offsetLeft, offsetWidth } = selectedElement;
        this.underlineTransform =
          this.underlineStyle === 'circle'
            ? `translateX(${
                offsetLeft + offsetWidth / 2 - parseFloat(this.circleRadius) / 2
              }px) translateY(60%)`
            : `translateX(${offsetLeft}px)`;

        this.underlineWidth =
          this.underlineStyle === 'circle' ? this.circleRadius : `${offsetWidth}px`;

        this.changeDetection.markForCheck(); // Ensure change detection runs
      }
    }
  }
}
